import {physiciansResource} from './physiciansResource';
import {clientsResource} from './clientsResource';
import {salesResource} from './salesResource';

export const resourcesConfig = {
    physicians: physiciansResource,
    clients: clientsResource,
    sales: salesResource
}